import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d869970")

_pushScopeId("data-v-7d869970")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "page" }
const _hoisted_3 = {
  class: "img-wrapper",
  id: "wrapper"
}
const _hoisted_4 = { name: "clickmap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h5", _hoisted_2, " Page " + _toDisplayString(_ctx.pageId) + " (Navigate clicking right or left on the image) ", 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("img", {
        src: _ctx.currentPage,
        usemap: "#clickmap"
      }, null, 8, ["src"]),
      _createVNode("map", _hoisted_4, [
        _createVNode("area", {
          shape: "rect",
          coords: _ctx.linkCoordinates.prev,
          href: _ctx.prevPage
        }, null, 8, ["coords", "href"]),
        _createVNode("area", {
          shape: "rect",
          coords: _ctx.linkCoordinates.next,
          href: _ctx.nextPage
        }, null, 8, ["coords", "href"])
      ])
    ])
  ]))
})